// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"Layout_closeButton__y6ESN","leftToRight":"Layout_leftToRight__n_yK7"};